// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3OkJQ","content":"RecentSearches_content__3n6WS"};